import type {
    ActiveReportDetail,
    ReportDictionaryItem,
    ReportPrintVariant,
    ShipmentReportDetail
} from '@/api/schemas/reports/common'
import type { CreateReportPayloadSchema, ReportAdditionalAction, ReportTaskDetails } from '@/api/schemas/reports/reportExecution'
import type { OperatorReportingCreateContext } from '@/stores/reportsV2/reportExecution/types'

import type { ReportDetailOrigin, ReportExecutionState } from './state'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function createReportExecutionActions(state: ReportExecutionState) {
    const setActiveReportId = (reportId: number | null): void => {
        state.activeReportId.value = reportId
    }

    const setActiveReport = (report: ActiveReportDetail | null): void => {
        state.activeReport.value = report
        state.activeReportId.value = report?.id ?? null
        state.printVariant.value = report?.printVariant ?? null
    }

    const setActiveShipmentReport = (report: ShipmentReportDetail | null): void => {
        state.activeShipmentReport.value = report
    }

    const setDetailOrigin = (origin: ReportDetailOrigin): void => {
        state.detailOrigin.value = origin
    }

    const setPrintVariant = (printVariant: ReportPrintVariant): void => {
        state.printVariant.value = printVariant
    }

    const setReportDraft = (payload: CreateReportPayloadSchema | null): void => {
        state.reportDraft.value = payload
    }

    const setOperatorReportingCreateContext = (payload: OperatorReportingCreateContext | null): void => {
        state.operatorReportingCreateContext.value = payload
    }

    const setPrefetchedCreateTask = (task: ReportTaskDetails | null): void => {
        state.prefetchedCreateTask.value = task
    }

    const setCommentCodes = (codes: ReportDictionaryItem[]): void => {
        state.commentCodes.value = codes
    }

    const setAdditionalActions = (actions: ReportAdditionalAction[]): void => {
        state.additionalActions.value = actions
    }

    const resetCreateBootstrapState = (): void => {
        state.reportDraft.value = null
        state.operatorReportingCreateContext.value = null
        state.prefetchedCreateTask.value = null
        state.commentCodes.value = []
        state.additionalActions.value = []
    }

    const resetExecutionContext = (): void => {
        state.activeReportId.value = null
        state.activeReport.value = null
        state.activeShipmentReport.value = null
        state.detailOrigin.value = null
        state.printVariant.value = null
        resetCreateBootstrapState()
    }

    return {
        setActiveReportId,
        setActiveReport,
        setActiveShipmentReport,
        setDetailOrigin,
        setPrintVariant,
        setReportDraft,
        setOperatorReportingCreateContext,
        setPrefetchedCreateTask,
        setCommentCodes,
        setAdditionalActions,
        resetCreateBootstrapState,
        resetExecutionContext
    }
}
